export default __webpack_public_path__ + "static/media/mobile_mock.caf73337.png";